import { markInstanceOfUserHighlight } from './markUserHighlight';
import { markInstanceOfUserNote } from './markUserNote';
import KeywordMarkupData from '../store/schema/KeywordMarkupData';
import { ClientItem } from 'owa-mail-store';
import { UNMARK_ELEMENT_LABEL } from 'owa-mark/lib/utils/constants';

export default function markInstanceOfUserMarkup(
    element: HTMLElement,
    item: ClientItem,
    keyword: string,
    instance: number,
    markupData: KeywordMarkupData
) {
    if (!markupData) {
        return;
    }
    if (markupData.isNote && markupData.noteInstances?.has(instance)) {
        // If a matching instance of a note is attached to this element,
        // mark it as a note
        markInstanceOfUserNote(element, item, keyword, instance);
    } else if (markupData.isHighlight) {
        // If a highlight (and not a matching instance of a note),
        // mark it as a highlight
        markInstanceOfUserHighlight(element, item, keyword);
    } else if (markupData.isNote) {
        // Otherwise, label this element to be unmarked
        element.classList.add(UNMARK_ELEMENT_LABEL);
    }
}
